<template>
  <div class="postcode-input">
    <div class="form-group row" :class="{ 'has-feedback' : isDirty }">
      <label :for="options.name" :class="options.fullWidth ? 'col-sm-12' : 'col-sm-4 col-form-label'">
        {{ options.label }}
        <span v-if="options.required" class="required">*</span>
      </label>
      <div :class="options.fullWidth ? 'col-sm-12' : 'col-sm-8'">
        <input class="form-control" type="text"
          :id="options.name"
          @input="validate($event.target.value)"
          :value="value"
          :name="options.name"/>
        <span :class="validationClass" v-show="validationMessage">
          {{ validationMessage }}
        </span>
        <span :class="validationIcon" v-show="validationIcon"></span>
      </div>
    </div>
  </div>
</template>

<script>
import {
  validationClass,
  validationMessage,
  validationIcon
} from '@/util/helpers'

export default {
  name: 'PostcodeInput',
  props: {
    value: {
      type: String
    },
    options: {
      type: Object,
      default () {
        return {
          value: '',
          valid: false,
          dirty: false
        }
      }
    }
  },
  data () {
    return {
      invalidMessage: 'Postcode entered is not valid',
      isLength: false,
      isRegex: false,
      isDirty: false,
      isValid: false,
      minLength: 1,
      regex: /^[0-9]{4}$/
    }
  },
  computed: {
    validationClass,
    validationMessage,
    validationIcon
  },
  methods: {
    validate (val = this.value) {
      this.$emit('input', val)
      this.isDirty = true
      if (val) {
        this.isLength = this.isValid = val.length > this.minLength
        if (this.isLength) {
          this.isRegex = this.isValid = new RegExp(this.regex, 'gi').test(val)
        }
      } else if (this.options.required) {
        this.isValid = false
      } else {
        this.isValid = true
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/inputs/PostcodeInput.vue